import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'
export default class AgentiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.baseApi = `${services.ask_base_api.url}`
    this.filemanager = new FileManager()
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/agenti/firmatari/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'name',
        label: 'Nome Cognome',
        sortable: true,
        default: true,
      },
      {
        property: "email",
        label: "Email",
        default: true,
      },
      {
        property: "telefono",
        label: "Telefono",
        default: true,
      },
      {
        property: "partita_iva",
        label: "Partita iva",
        default: true,
      },
      {
        property: "note",
        label: "Note",
        default: true,
      },
      
    ]
  }

  async getDettaglioAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async sendAgentLoginEmail(name, email, area, forceMail, ccnMail){
    let success = false

    const url = `${this.baseApi}/agent/access-email`
    try {
      let res = await this.http.post(url, {name, email, area, forceMail, ccnMail})
      success = res.data.status
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async updateAgentiAccessDate(email){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/access-date/update`
    try {
      let res = await this.http.post(url, {email, type:'agente'})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async changeAgenteCanView(item){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/can-view/update`
    try {
      let res = await this.http.post(url, {item})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async uploadModulo(file, idAgente, isGlobal){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/clienti/agenti/modulo/upload`
    let fd = new FormData();
    fd.append('title', file.title);
    fd.append('isGlobal', isGlobal);
    fd.append('idAgente', idAgente);
    for (let i = 0 ; i < file.file.length ; i++) {
      fd.append('files[]', file.file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)

      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }
    }

  }


  async downloadAgenteModulo(code){

    const url = `${this.baseUrl}/clienti/agenti/modulo/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {code},
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async deleteAgenteModulo(code){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/modulo/delete`
    try {
      let res = await this.http.post(url, {code})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async associateAgenteOfferte(agenti,offerte){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/associate/offerte`
    try {
      let res = await this.http.post(url, {agenti,offerte})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async dissociateAgenteOfferte(agenti,offerte){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/dissociate/offerte`
    try {
      let res = await this.http.post(url, {agenti,offerte})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }
  async associateAgencyToAgent(idAgent, idAgency){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/associate/agency`
    try {
      let res = await this.http.post(url, {idAgent, idAgency})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }
  async associateSubagentsToAgent(idAgent, subagents){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/associate/subagents`
    try {
      let res = await this.http.post(url, {idAgent, subagents})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async dissociateSubagenti(idAgente,subagente){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/dissociate/subagente`
    try {
      let res = await this.http.post(url, {idAgente,subagente})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async applyNewGroupOfferteToAgent(agente,offerte){
    let success = false

    const url = `${this.baseUrl}/agenti/relation/subagents/tree/offerte/associate`
    try {
      let res = await this.http.post(url, {agente,offerte})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async getAgentsReportPdp(year){
    let items = {}

    const url = `${this.baseUrl}/clienti/agenti/pdp/report/${year}`
    try {
      let res = await this.http.get(url, {year})
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

}
